function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#757575;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "matrix(0.839, 0.545, -0.545, 0.839, 40.678, 6)"
}, React.createElement("g", {
  transform: "matrix(0.839, -0.545, 0.545, 0.839, -49.529, -1.58)"
}, React.createElement("g", {
  transform: "translate(0 22.301)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M44.1,56.434A3.869,3.869,0,0,0,46.842,54.5l8.7-15.683a3.868,3.868,0,0,0-6.766-3.751L40.979,49.118l-10.621,1.8-9.546-.864,1.231,2.359L13.26,43.1l-.467-17.037a3.868,3.868,0,0,0-7.733.212l.507,18.511A3.87,3.87,0,0,0,6.62,47.334L16.415,57.72l-3.459-2.071c0,.027,0,.054,0,.081l.213,28.027H10.525L6.379,51.011a3.2,3.2,0,0,0-6.353.8l4.5,35.545a3.2,3.2,0,0,0,3.176,2.8H19.542v13.994H16.286a2.134,2.134,0,0,0-1.509.625L10.9,108.657a2.135,2.135,0,0,0,3.019,3.019l3.252-3.251h8.737l3.251,3.251a2.135,2.135,0,0,0,3.019-3.019L28.3,104.78a2.136,2.136,0,0,0-1.509-.625h-2.98V90.161h9.526a3.2,3.2,0,0,0,3.187-2.9l.611.158L39.8,108.247A4.642,4.642,0,1,0,49,107.07L45.944,83.119A4.642,4.642,0,0,0,42.5,79.213l-9.651-2.492L34.17,58.117Z",
  transform: "translate(0 -22.301)"
}))), React.createElement("g", {
  transform: "translate(17.495 28.991)"
}, React.createElement("circle", {
  className: "a",
  cx: 8.538,
  cy: 8.538,
  r: 8.538
})), React.createElement("g", {
  transform: "translate(48.853 52.367)"
}, React.createElement("path", {
  className: "a",
  d: "M300.244,196.3H273.159a2.666,2.666,0,0,0,1.036-1.044l7.044-12.857a2.668,2.668,0,0,0-4.68-2.564L270.274,191.3H259.016a2.667,2.667,0,0,0-1.3,4.994h-.8a3.2,3.2,0,0,0-.64,6.339v32.54a3.2,3.2,0,0,0,6.4,0V202.7h32.018v32.476a3.2,3.2,0,0,0,6.4,0V202.583a3.2,3.2,0,0,0-.854-6.285Z",
  transform: "translate(-253.711 -178.446)"
})), React.createElement("g", {
  transform: "translate(63.956 49.349)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M333.916,162.773c-1,0-1.772.425-1.772,1.6v1.678c0,1.17.768,1.6,1.772,1.6s1.773-.425,1.773-1.6v-1.678C335.689,163.2,334.909,162.773,333.916,162.773Zm.591,3.273a.518.518,0,0,1-.591.567.51.51,0,0,1-.579-.567v-1.678a.51.51,0,0,1,.579-.567.518.518,0,0,1,.591.567Z",
  transform: "translate(-332.144 -162.773)"
}))), React.createElement("g", {
  transform: "translate(58.532 45.544)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M305.748,143.012c-1,0-1.772.425-1.772,1.6v1.678c0,1.17.768,1.6,1.772,1.6s1.772-.426,1.772-1.6v-1.678C307.521,143.437,306.741,143.012,305.748,143.012Zm.591,3.273a.518.518,0,0,1-.591.567.51.51,0,0,1-.579-.567v-1.678a.509.509,0,0,1,.579-.567.518.518,0,0,1,.591.567Z",
  transform: "translate(-303.976 -143.012)"
}))), React.createElement("g", {
  transform: "translate(60.343 45.06)"
}, React.createElement("path", {
  className: "a",
  d: "M318.082,140.5a.521.521,0,0,0-.5.3l-4.148,8.52a.619.619,0,0,0,.6.851.591.591,0,0,0,.531-.3l4.159-8.519A.64.64,0,0,0,318.082,140.5Z",
  transform: "translate(-313.382 -140.496)"
})), React.createElement("g", {
  transform: "translate(70.141 33.831)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M368.966,82.182a.521.521,0,0,0-.5.3L364.322,91a.531.531,0,0,0-.059.225.654.654,0,0,0,.662.627.591.591,0,0,0,.531-.3l4.159-8.52a.512.512,0,0,0,.048-.225A.678.678,0,0,0,368.966,82.182Z",
  transform: "translate(-364.263 -82.182)"
}))), React.createElement("g", {
  transform: "translate(68.333 34.316)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M356.646,84.7c-1,0-1.772.425-1.772,1.6v1.678c0,1.17.768,1.6,1.772,1.6s1.772-.425,1.772-1.6V86.293C358.419,85.124,357.639,84.7,356.646,84.7Zm.591,3.273a.518.518,0,0,1-.591.567.509.509,0,0,1-.579-.567V86.294a.51.51,0,0,1,.579-.567.519.519,0,0,1,.591.567Z",
  transform: "translate(-354.874 -84.698)"
}))), React.createElement("g", {
  transform: "translate(73.756 38.121)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M384.813,104.459c-1,0-1.772.426-1.772,1.6v1.678c0,1.17.768,1.6,1.772,1.6s1.773-.425,1.773-1.6v-1.678C386.586,104.885,385.806,104.459,384.813,104.459Zm.591,3.273a.518.518,0,0,1-.591.567.51.51,0,0,1-.579-.567v-1.678a.51.51,0,0,1,.579-.567.518.518,0,0,1,.591.567Z",
  transform: "translate(-383.041 -104.459)"
}))), React.createElement("g", {
  transform: "translate(63.805 28.035)"
}, React.createElement("path", {
  className: "a",
  d: "M332.578,52.08c-.688,0-1.215.292-1.215,1.094v1.15c0,.8.527,1.094,1.215,1.094s1.215-.292,1.215-1.094v-1.15C333.793,52.371,333.258,52.08,332.578,52.08Zm.405,2.244a.355.355,0,0,1-.4.389.349.349,0,0,1-.4-.389v-1.15a.349.349,0,0,1,.4-.389.355.355,0,0,1,.4.389Z",
  transform: "translate(-331.363 -52.08)"
})), React.createElement("g", {
  transform: "translate(60.088 25.426)"
}, React.createElement("path", {
  className: "a",
  d: "M313.27,38.533c-.688,0-1.215.292-1.215,1.094v1.15c0,.8.526,1.094,1.215,1.094s1.215-.292,1.215-1.094v-1.15C314.485,38.825,313.95,38.533,313.27,38.533Zm.4,2.244a.355.355,0,0,1-.4.389.349.349,0,0,1-.4-.389v-1.15a.349.349,0,0,1,.4-.389.355.355,0,0,1,.4.389Z",
  transform: "translate(-312.055 -38.533)"
})), React.createElement("g", {
  transform: "translate(61.327 25.094)"
}, React.createElement("g", {
  transform: "translate(0 0)"
}, React.createElement("path", {
  className: "a",
  d: "M321.715,36.809a.357.357,0,0,0-.34.2l-2.843,5.84a.367.367,0,0,0-.04.154.448.448,0,0,0,.454.429.406.406,0,0,0,.365-.2l2.851-5.84a.352.352,0,0,0,.033-.154A.464.464,0,0,0,321.715,36.809Z",
  transform: "translate(-318.491 -36.809)"
})))));

var SvgContentmentImg = function SvgContentmentImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 98.588,
    height: 90,
    viewBox: "0 0 98.588 90",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContentmentImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contentment_img.25d0652d.svg";
export { ForwardRef as ReactComponent };